import http from "./http";

class AuteursService {
    index(){
        return http.get("/api/auteurs")
    }

    store(data,token){
        return http.post("/api/auteurs/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/auteurs/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/auteurs/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/auteurs/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/auteurs/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new AuteursService()